import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import Routes from './Routes';
import reportWebVitals from './reportWebVitals';
import { UiProvider } from './context/UiContext';
import { initAnalytics } from './analytics';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <UiProvider>
      <Routes />
      <ToastContainer position="top-right" autoClose={4000} newestOnTop closeOnClick pauseOnFocusLoss draggable pauseOnHover theme="colored" />
    </UiProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Initialize GA4 with default ID unless overridden by env
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-ZYJZJHEXNV';
initAnalytics(GA_ID);
